'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('flexDirection');


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/flex-direction.js
// module id = 55
// module chunks = 35783957827783 114276838955818 182246549230831